import { Component, OnInit, Input } from '@angular/core';
import { DatewiseEvents } from '../../models/datewise-events';
import { DatePipe } from '@angular/common';
import { DateUtils } from '../../../../../utils/date-utils';

@Component({
  selector: 'app-calendar-cell',
  templateUrl: './calendar-cell.component.html',
  styleUrls: ['./calendar-cell.component.scss']
})
export class CalendarCellComponent implements OnInit {

  @Input() day: DatewiseEvents;
  @Input() isSameMonth: boolean;
  todaysdate = DateUtils.DateToISOString(new Date()).split('T')[0];
  constructor(private datePipe: DatePipe) { }

  ngOnInit() {
  }

}
